/* IMPORT */
import { UNAVAILABLE } from '../constants.js';
import { SYMBOL_OBSERVABLE_READABLE, SYMBOL_OBSERVABLE_WRITABLE } from '../symbols.js';
import { isFunction } from '../utils.js';
/* MAIN */
const target = (observable) => {
    if (isFunction(observable)) {
        return observable[SYMBOL_OBSERVABLE_READABLE] || observable[SYMBOL_OBSERVABLE_WRITABLE] || UNAVAILABLE;
    }
    else {
        return observable;
    }
};
/* EXPORT */
export default target;
